var map = {
	"./Furniture - store.png": 454,
	"./Myntra-clone.png": 8648,
	"./Repogit.png": 1271,
	"./Trivago_in.png": 1414,
	"./fabally.png": 4260,
	"./hotstar.png": 100,
	"./movieStation.png": 696,
	"./portfolio.png": 2014,
	"./shop_com.png": 7555
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1393;